import { render, staticRenderFns } from "./coursecatalogs.vue?vue&type=template&id=e654fa48&scoped=true&"
import script from "./coursecatalogs.vue?vue&type=script&lang=js&"
export * from "./coursecatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e654fa48",
  null
  
)

export default component.exports